import script from "./Score.vue?vue&type=script&setup=true&lang=js"
export * from "./Score.vue?vue&type=script&setup=true&lang=js"

import "./Score.vue?vue&type=style&index=0&id=7c1c7d1a&lang=scss&scoped=true"

import exportComponent from "/Users/oleksandrpolishchuk/Documents/dev/eye-test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1c7d1a"]])

export default __exports__